import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { id: "nav-drawer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("input", {
  id: "nav-input",
  type: "checkbox",
  class: "nav-unshown"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  id: "nav-open",
  for: "nav-input"
}, [
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "nav-unshown",
  id: "nav-close",
  for: "nav-input"
}, null, -1)
const _hoisted_5 = { id: "nav-content" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "lang_select_div" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "move_select_div" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "cp_navi" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "lang_select_div" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "move_select_div" }
const _hoisted_16 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerLinks, (headerLink) => {
            return (_openBlock(), _createElementBlock("li", { key: headerLink }, [
              (_ctx.isExternalUrl(headerLink.link))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: _ctx.routerPath(headerLink.link),
                    onclick: "document.getElementById('nav-input').checked=false;"
                  }, _toDisplayString(headerLink.text), 9, _hoisted_6))
                : (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: _ctx.routerPath(headerLink.link),
                    onclick: "document.getElementById('nav-input').checked=false;"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(headerLink.text), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("select", {
            class: "lang_select",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.SelectedLanguage) = $event)),
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.ChangeLanguage && _ctx.ChangeLanguage(...args)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languageSelects, (languageSelect) => {
              return (_openBlock(), _createElementBlock("option", {
                value: languageSelect.value,
                key: languageSelect
              }, _toDisplayString(languageSelect.text), 9, _hoisted_8))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.SelectedLanguage]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("select", {
            class: "move_select",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.SelectedBackgroundMove) = $event)),
            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.ChangeBackgroundMove && _ctx.ChangeBackgroundMove(...args)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.backMoveSelects, (backMoveSelect) => {
              return (_openBlock(), _createElementBlock("option", {
                value: backMoveSelect.value,
                key: backMoveSelect
              }, _toDisplayString(backMoveSelect.text), 9, _hoisted_10))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.SelectedBackgroundMove]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerLinks, (headerLink) => {
          return (_openBlock(), _createElementBlock("li", { key: headerLink }, [
            (_ctx.isExternalUrl(headerLink.link))
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: _ctx.routerPath(headerLink.link)
                }, _toDisplayString(headerLink.text), 9, _hoisted_12))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: _ctx.routerPath(headerLink.link)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(headerLink.text), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_13, [
          _withDirectives(_createElementVNode("select", {
            class: "lang_select",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.SelectedLanguage) = $event)),
            onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.ChangeLanguage && _ctx.ChangeLanguage(...args)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languageSelects, (languageSelect) => {
              return (_openBlock(), _createElementBlock("option", {
                value: languageSelect.value,
                key: languageSelect
              }, _toDisplayString(languageSelect.text), 9, _hoisted_14))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.SelectedLanguage]
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _withDirectives(_createElementVNode("select", {
            class: "move_select",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.SelectedBackgroundMove) = $event)),
            onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.ChangeBackgroundMove && _ctx.ChangeBackgroundMove(...args)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.backMoveSelects, (backMoveSelect) => {
              return (_openBlock(), _createElementBlock("option", {
                value: backMoveSelect.value,
                key: backMoveSelect
              }, _toDisplayString(backMoveSelect.text), 9, _hoisted_16))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.SelectedBackgroundMove]
          ])
        ])
      ])
    ])
  ], 64))
}